module.exports = __webpack_public_path__ + "img/s00166.cb0e25be.png";